import type { Money } from '@urbanrats/contracts';
import { useI18n } from '../i18n/index.ts';
import { fmtAtomic, fmtDateTime } from '../lib/format.ts';
import { useDisplay } from '../lib/fx.ts';

/**
 * "~12.34 USD" next to a wallet amount when a display currency is chosen and a fresh quote exists.
 * Never shown as a settlement value; a stale quote shows no number.
 */
export function Approx({ money, className = '' }: { money: Money; className?: string }) {
  const { t, intl } = useI18n();
  const { approx } = useDisplay();
  const r = approx(money);
  if (!r || r.kind === 'NO_QUOTE') return null;
  if (r.kind === 'STALE')
    return (
      <span className={`approx stale ${className}`} data-testid="approx">
        ~ {t('approx.stale')}
      </span>
    );
  const amount = fmtAtomic(r.amountAtomic, r.scale, r.currency, intl);
  return (
    <span
      className={`approx ${className}`}
      data-testid="approx"
      title={t('approx.title', { provider: r.quote.provider, rateId: r.quote.rateId, asOf: fmtDateTime(r.quote.asOf, intl), wallet: money.currency })}
    >
      {t('approx.value', { amount })}
    </span>
  );
}
